import Vue from 'vue'
import Router from 'vue-router'
import HomePage from "../views/HomePage";
import ProductPage from "../views/ProductPage";
import JoinPage from "../views/JoinPage";
import CompanyPage from "../views/CompanyPage";
import ContactPage from "../views/ContactPage";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: HomePage
        },
        {
            path: '/prod',
            name: 'prod',
            component: ProductPage
        },
        {
            path: '/join',
            name: 'join',
            component: JoinPage
        },
        {
            path: '/company',
            name: 'company',
            component: CompanyPage
        },
        {
            path: '/contact',
            name: 'contact',
            component: ContactPage
        }
    ]
})
